import Pusher from 'pusher-js';

const pusher = new Pusher('a05559032cd8d6483df3', {
    appId: '1645087',
    secret: 'bb61f746774fbe6ef6df',
    cluster: 'sa1',
    encrypted: true,
});
export default pusher;